import { render, staticRenderFns } from "./InsuranceRegister.vue?vue&type=template&id=276c8aae&scoped=true"
import script from "./InsuranceRegister.vue?vue&type=script&lang=js"
export * from "./InsuranceRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276c8aae",
  null
  
)

export default component.exports